import {
    Box,
    Icon,
    IconButton,
    MobileStepper,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import PhotoLoader from "../../../components/shared/PhotoLoader";
import {
    DefaultDarkProjectImagePath,
    DefaultProjectImagePath,
} from "../../../constants/ProjectConstants";
import { DialogContext } from "../../../contexts/DialogContext";
import { RootState } from "../../../slices/Store";
import { toJalaliDate } from "../../../utils/date";
import ProjectPhotoGallery from "../../projects/dialogs/ProjectPhotoGallery";

// updated
export default function ProjectDetailDesktopPhotos() {
    const { openDialog } = useContext(DialogContext);
    const theme = useTheme();

    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const [selectedPhotoIndex, setSelectedPhotoIndex] = useState<number>(0);

    const projectPlaceHolder =
        theme.palette.mode === "light"
            ? DefaultProjectImagePath
            : DefaultDarkProjectImagePath;

    const openProjectGallery = (index: number = 0) => {
        openDialog(
            <ProjectPhotoGallery
                selectedIndex={index}
                photos={projectDetailState.projectDetail.photos}
            />
        );
    };

    const showCaseImageLength = 4;
    const imageWidth = 503;
    const imageHeight = 323;
    const showCaseImageWidth = 105;
    const showCaseImageHeight = 70;
    const defaultBorderRadius = "8px";

    const photos = projectDetailState.projectDetail.photos.slice(0, 25);

    const showCasePhotos = projectDetailState.projectDetail.photos.slice(
        0,
        showCaseImageLength
    );

    const hasPhoto = projectDetailState.projectDetail.photos.length > 0;
    const showMoreImages =
        projectDetailState.projectDetail.photos.length > showCaseImageLength;

    const handleNext = () => {
        setSelectedPhotoIndex((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setSelectedPhotoIndex((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <Box sx={{ px: 2, mb: 2 }}>
            <Box
                sx={{
                    position: "relative",
                    overflow: "hidden",
                    width: "100%",
                    height: imageHeight,
                    borderRadius: "8px",
                }}
            >
                {/* main photo */}
                <PhotoLoader
                    onClick={() => (hasPhoto ? openProjectGallery() : null)}
                    style={{
                        cursor: "pointer",
                        borderRadius: defaultBorderRadius,
                        overflow: "hidden",
                        position: "absolute",
                        right: "50%",
                        transform: "translateX(50%)",
                        top: "0",
                    }}
                    width={imageWidth}
                    height={imageHeight}
                    src={
                        hasPhoto
                            ? photos[selectedPhotoIndex].imageUrl
                            : projectPlaceHolder
                    }
                />

                <IconButton
                    disabled={selectedPhotoIndex === photos.length - 1}
                    onClick={handleNext}
                    sx={{
                        position: "absolute",
                        right: 16,
                        top: "40%",
                        background: "rgba(0,0,0,0.1)",
                        backdropFilter: "blur(20px)",
                    }}
                >
                    <Icon sx={{ fontSize: "30px", color: "white" }}>
                        chevron_left
                    </Icon>
                </IconButton>

                <IconButton
                    disabled={selectedPhotoIndex === 0}
                    onClick={handleBack}
                    sx={{
                        position: "absolute",
                        left: 16,
                        top: "40%",
                        background: "rgba(0,0,0,0.1)",
                        backdropFilter: "blur(20px)",
                    }}
                >
                    <Icon sx={{ fontSize: "30px", color: "white" }}>
                        chevron_right
                    </Icon>
                </IconButton>

                <MobileStepper
                    sx={{
                        position: "absolute",
                        bottom: 0,
                        background: "rgba(0,0,0,0.1)",
                        height: "35px",
                        width: "100%",
                        justifyContent: "center",
                        backdropFilter: "blur(20px)",
                        border: "none",
                    }}
                    steps={photos.length}
                    position="static"
                    activeStep={selectedPhotoIndex}
                    nextButton={<></>}
                    backButton={<></>}
                />

                {hasPhoto && (
                    <Box
                        sx={{
                            position: "absolute",
                            right: 16,
                            top: 16,
                            background: "rgba(0,0,0,0.2)",
                            p: 1,
                            backdropFilter: "blur(20px)",
                            borderRadius: defaultBorderRadius,
                        }}
                    >
                        <Typography fontSize="small" color={"white"}>
                            {toJalaliDate(
                                photos[selectedPhotoIndex]?.shootingDate
                            )}
                        </Typography>
                    </Box>
                )}
            </Box>

            {hasPhoto && (
                <Stack direction="row" sx={{ mt: 2 }} spacing={2}>
                    {/* showcase photos */}
                    {showCasePhotos.map((p, i) => {
                        return (
                            <Box
                                onClick={() => openProjectGallery(i)}
                                key={p.imageId}
                                sx={{
                                    position: "relative",
                                    cursor: "pointer",
                                    overflow: "hidden",
                                    width: showCaseImageHeight,
                                    height: showCaseImageHeight,
                                    borderRadius: defaultBorderRadius,
                                }}
                            >
                                <PhotoLoader
                                    src={p.imageUrl}
                                    style={{
                                        position: "absolute",
                                        left: "-17.5px",
                                    }}
                                    width={showCaseImageWidth}
                                    height={showCaseImageHeight}
                                />
                            </Box>
                        );
                    })}

                    {/* gallery photo */}
                    {showMoreImages && (
                        <Box
                            onClick={() =>
                                openProjectGallery(showCaseImageLength)
                            }
                            sx={{
                                width: showCaseImageHeight,
                                height: showCaseImageHeight,
                                cursor: "pointer",
                                borderColor: "divider",
                                borderRadius: defaultBorderRadius,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                bgcolor: "background.paper",
                            }}
                        >
                            <Typography color="primary" fontSize="smaller">
                                +{" "}
                                {projectDetailState.projectDetail.photos
                                    .length - showCaseImageLength}{" "}
                                تصویر
                            </Typography>

                            <Icon color="primary">collections</Icon>
                        </Box>
                    )}
                </Stack>
            )}
        </Box>
    );
}
